/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { of, throwError } from "rxjs";
import { HttpRequestOptions } from "../../../../models/ui/http-request-options.model";
import { RUN_SIMULATION_RESPONSE } from "./what-if-simulation.db";
import { HttpParams } from "@angular/common/http";
import { isNullOrUndefined } from "../../../utils";
import { ApplicationError } from "../../../../models/ui/application-error.model";

export class WhatIfSimulation {
	public static runSimulation(options: HttpRequestOptions) {
		const { params, pathParams } = options;

		const httpParams = params as HttpParams;

		if (!httpParams)
			return throwError(
				() =>
					new ApplicationError(
						"No params provided",
						this.constructor.name,
						this.runSimulation.name
					)
			);

		const tenantId = httpParams.get("tenantId");

		if (!tenantId)
			return throwError(
				() =>
					new ApplicationError(
						"No tenant token provided",
						this.constructor.name,
						this.runSimulation.name
					)
			);

		const scenarioId = pathParams?.["scenarioId"];

		if (isNullOrUndefined(scenarioId))
			return throwError(
				() =>
					new ApplicationError(
						"Missing required path parameter",
						this.constructor.name,
						this.runSimulation.name
					)
			);

		return of(RUN_SIMULATION_RESPONSE);
	}
}
